<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('production_store.product_dashboard') }}</h4>
        </template>
      <template v-slot:body>
        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
        <b-form @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
          <b-row>
              <b-col lg="3" sm="12">
                  <ValidationProvider name="Product Cagetory" vid="category_id" rules="required|min_value:1">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="category_id"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                      {{$t('production_configuration.category_name')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                      plain
                      v-model="search.category_id"
                      :options="categoryList"
                      id="category_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                      {{ errors[0] }}
                      </div>
                  </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col lg="3" sm="12">
                  <ValidationProvider name="Sub-Cagetory" vid="sub_category_id" rules="">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="sub_category_id"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                      {{$t('production_configuration.sub_category_name')}}
                      </template>
                      <b-form-select
                      plain
                      v-model="search.sub_category_id"
                      :options="subCategoryList"
                      id="sub_category_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                      {{ errors[0] }}
                      </div>
                  </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col lg="3" sm="12">
                  <ValidationProvider name="Product" vid="product_id" rules="">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="product_id"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                      {{$t('production_configuration.product_name')}}
                      </template>
                      <b-form-select
                      plain
                      v-model="search.product_id"
                      :options="productList"
                      id="product_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                      {{ errors[0] }}
                      </div>
                  </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col lg="3" sm="12">
                  <ValidationProvider name="Unit" vid="unit_id" rules="">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="unit_id"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                      {{$t('production_configuration.unit_name')}}
                      </template>
                      <b-form-select
                      plain
                      v-model="search.unit_id"
                      :options="unitList"
                      id="unit_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                      {{ errors[0] }}
                      </div>
                  </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col xs="12" sm="12" md="3">
                  <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                  <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="fiscal_year_id"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                      {{$t('retailerManagement.fiscal_year')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                      plain
                      v-model="search.fiscal_year_id"
                      :options="fiscalYearList"
                      id="fiscal_year_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                      {{ errors[0] }}
                      </div>
                  </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col xs="12" sm="12" md="3">
                <ValidationProvider name="Month" vid="month" rules="required|min_value:1">
                  <b-form-group
                    class="row"
                    label-cols-sm="12"
                    label-for="month"
                    slot-scope="{ valid, errors }"
                    >
                    <template v-slot:label>
                    {{$t('production_store.month')}} <span class="text-danger">*</span>
                    </template>
                    <b-form-select
                      plain
                      v-model="search.month"
                      :options="monthList"
                      :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col sm="12" md="6" class="pt-4 mt-2">
          <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
              </b-col>
          </b-row>
        </b-form>
        </ValidationObserver>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('production_store.product') + ' ' + $t('globalTrans.list')}}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="dataList" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(product_id)="data">
                      {{ productNameById(data.item.product_id) }}
                    </template>
                    <template v-slot:cell(unit_id)="data">
                      {{ unitNameById(data.item.unit_id) }}
                    </template>
                     <template v-slot:cell(status)="data">
                        <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                        <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template>
                    <template v-slot:cell(closing_amount)="data">
                       {{ getClosingAmount(data.item) }}
                    </template>
                    <template v-slot:cell(total_amount)="data">
                       {{ getTotalAmount(data.item) }}
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { productDashboard } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import flatpickr from 'flatpickr'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ExportPdf from './export-pdf_details'

export default {
  mixins: [RouteBasedList],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        month: 0,
        category_id: 0,
        sub_category_id: 0,
        product_id: 0,
        unit_id: 0,
        start_date: '',
        end_date: ''
      },
      subCategoryList: [],
      productList: [],
      unitList: [],
      showList: false,
      dataList: []
    }
  },
  watch: {
    'search.category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.subCategoryList = this.getSubCatList(newVal)
        this.productList = this.getProductListByCat(newVal)
      }
    },
    'search.sub_category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.productList = this.getProductList(newVal)
      }
    },
    'search.product_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.unitList = this.getUnitList(newVal)
      }
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setStartEndDate(newVal)
      }
    },
    currentLocale: function (newVal, oldVal) {
      if (newVal !== oldVal) {
          if (this.search.category_id) {
          this.subCategoryList = this.getSubCatList(this.search.category_id)
          this.productList = this.getProductListByCat(this.search.category_id)
          }
          if (this.search.sub_category_id) {
          this.productList = this.getProductList(this.search.sub_category_id)
          }
          if (this.search.product_id) {
          this.unitList = this.getUnitList(this.search.product_id)
          }
      }
    }
  },
  computed: {
    monthList: function () {
      return this.$store.state.commonObj.monthList.filter(item => {
        if (this.$i18n.locale === 'bn') {
          return Object.assign(item, { text: item.text_bn })
        } else {
          return Object.assign(item, { text: item.text_en })
        }
      })
    },
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    formTitle () {
       return this.$t('production_store.product_dashboard') + ' ' + this.$t('globalTrans.details')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('production_configuration.product_name'), class: 'text-left' },
          { label: this.$t('production_configuration.unit_name'), class: 'text-left' },
          { label: this.$t('production_store.opening_stock') + ' ' + this.$t('production_store.pcs'), class: 'text-left' },
          { label: this.$t('production_store.stock_amount') + ' ' + this.$t('production_store.pcs'), class: 'text-left' },
          { label: this.$t('production_store.delivery') + ' ' + this.$t('production_store.pcs'), class: 'text-left' },
          { label: this.$t('production_store.closing') + ' ' + this.$t('production_store.pcs'), class: 'text-left' },
          { label: this.$t('production_store.total_amount') + ' ' + this.$t('production_store.pcs'), class: 'text-left' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'product_id' },
          { key: 'unit_id' },
          { key: 'opening_qty' },
          { key: 'stock_qty' },
          { key: 'deliver_qty' },
          { key: 'closing_amount' },
          { key: 'total_amount' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'product_id' },
          { key: 'unit_id' },
          { key: 'opening_qty' },
          { key: 'stock_qty' },
          { key: 'deliver_qty' },
          { key: 'closing_amount' },
          { key: 'total_amount' }
        ]
      }
      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  mounted () {
    flatpickr('#from_date', {})
    flatpickr('#to_date', {})
  },
  methods: {
    getSubCatList (catId) {
      return this.productCommonObj.productSubCategoryList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 1)
    },
    getProductListByCat (catId) {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 1)
    },
    getProductList (subCatId) {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.sub_category_id === subCatId && item.type_id === 1)
    },
    getUnitList (proId) {
      return this.productCommonObj.productUnitList.filter(item => item.product_id === proId && item.status === 1)
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, productDashboard, params).then(response => {
          if (response.success) {
             this.dataList = response.data
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    formatList (data) {
      return data.map(item => {
        return Object.assign(item, { memo_no: item.purchase?.memo_no })
      })
    },
    setStartEndDate (Id) {
      const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(item => item.value === Id)
      if (typeof fiscalYear !== 'undefined') {
        this.search.start_date = fiscalYear.start_date
        this.search.end_date = fiscalYear.end_date
      }
    },
    getClosingAmount (item) {
      const closingAmount = parseInt(item.stock_qty) - parseInt(item.deliver_qty)
      return closingAmount || 0
    },
    getTotalAmount (item) {
      const totalAmount = parseInt(item.opening_qty) + parseInt(item.stock_qty) - parseInt(item.deliver_qty)
      return totalAmount || 0
    },
    unitNameById (id) {
        const unit = this.$store.state.ProductionService.commonObj.productUnitList.find(unit => unit.value === id)
        if (typeof unit === 'undefined') {
          return ''
        } else {
          return unit.text
        }
    },
    productNameById (id) {
        const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === id)
        if (typeof product === 'undefined') {
          return ''
        } else {
          return product.text
        }
    },
    pdfExport () {
      const reportTitle = this.$t('production_store.monthly_stock_report')
      ExportPdf.exportPdfDetails(productionServiceBaseUrl, 'configuration/report-heading/detail', 2, reportTitle, this.report_data, this, this.monthname, this.year)
    }
  }
}
</script>
